// extracted by mini-css-extract-plugin
export var chevron = "_3h-2";
export var chevronCollapsed = "_3h-3";
export var collapsibleHeader = "_3h-1";
export var container = "_3h-0";